/* eslint-disable */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import { Paper, Button, Divider, Menu, MenuItem } from '@material-ui/core';
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';
import { useDispatch, useSelector } from 'react-redux';
import { Alert } from '@mui/material';
import { toast } from 'react-toastify';
import JourneyCard from './JourneyCard';
import { JourneyAddnewGuide } from './JourneyAddnewGuide';
import Theme from '../ui/Theme';

import {
  getGuideID,
  getJourneyDetails,
  showProgress,
  getCapstoneDetails,
  getCapstoneID,
  getCapstoneActivityList,
  getCapstoneActivityID,
  getLevelDetails,
} from '../../redux/actions/DealershipActions';
import AddNewCapstone from './AddNewCapstone';
import AddNewCapstoneLayout from './AddCapstoneLayout';
import { CapstoneActivityPopup } from './CapstoneActivityPopup';
import ChangeOrderLevel from './ChangeOrderLevel';
import ChangeLevelGuide from './ChangeLevelGuide';
import ChangeOrderGuide from './ChangeOrderGuide';
import FeatherPlus from '../../assets/FeatherPlus';
import service from '../../apis/service';
import { ErrorToast, notifySuccess, formatDurationSeconds } from '../utils/Utils';
import HandleCheckin from './HandleCheckin';
import { apiEndpoints } from '../../constants/apiEndpoints';
import { Takeaway } from './Takeaway';
import AddAiExercise from './components/AddAiExercise';
import CustomButton from '../shared/CustomButton';
toast.configure();
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={2}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}
TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};
const useStyles = makeStyles(() => ({
  root: {
    backgroundColor: Theme.palette.secondary.main,
    padding: 0,
  },

  menuRoot: {
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '600',
    fontSize: '14px',
    lineHeight: '20px',
    /* identical to box height, or 143% */

    display: 'flex',
    alignItems: 'center',
    textAlign: 'right',

    /* Absolute (dark) */

    color: 'black',
  },
  journeyLevelTitle: {
    fontSize: '20px',
    fontWeight: 600,

    textAlign: 'left',
    lineHeight: '24px',
    padding: '0px',
    paddingTop: '20px',
    paddingLeft: '18px',
    marginBottom: '8px',
  },
  leveldur: {
    fontSize: '12px',
    fontWeight: 'normal',

    lineHeight: '15px',
    textAlign: 'left',
    padding: '0px',
    marginBottom: '20px',
    paddingLeft: '18px',
  },
  addAiExerciseText: {
    fontFamily: 'Lato',
    fontSize: '10px',
    fontWeight: '600',
    lineHeight: '14px',
    textAlign: 'center',
    color: '#622FEE',
    textDecoration: 'underline',
    paddingBottom: '5px',
    cursor: 'pointer',
  },
}));
export default function SalesTeam(props) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [anchorElc, setAnchorElc] = React.useState(null);

  const levelDetails = useSelector((state) => state.getLevelDetails);
  const capstoneDetails = useSelector((state) => state.getCapstoneDetails);
  const capstoneID = useSelector((state) => state.getCapstoneID);
  const levelIds = useSelector((state) => state.JourneyDetails.journeydetails.levels);
  const levelID = useSelector((state) => state.getSelectedLevelID);
  const levelKey = useSelector((state) => state.getSelectedLevelKey);
  const [showCapAlert, setShowCapAlert] = useState(false);
  const journeyDetails = useSelector((state) => state.JourneyDetails.journeydetails);

  const [showAddNewGuide, setShowAddNewGuide] = useState(false);
  const [showAddNewAiExercise, setShowAddNewAiExercise] = useState(false);
  const [showCapstoneAct, setShowCapstoneAct] = useState(false);
  const [showChangeOrder, setShowChangeOrder] = useState(false);
  const [showChangeOrderGuide, setShowChangeOrderGuide] = useState(false);
  const [showChangeLevelGuide, setShowChangeLevelGuide] = useState(false);
  const [showAddNewCapstone, setShowAddNewCapstone] = useState(false);
  const [showEditNewCapstone, setShowEditNewCapstone] = useState(false);
  const [showViewGuide, setShowViewGuide] = useState(false);
  const [selectedGuide, setSelectedGuide] = useState([]);
  const [showAddCheckin, setShowAddCheckin] = useState(false);
  const [showUpdateCheckin, setShowUpdateCheckin] = useState(false);
  const [showAddTakeaways, setShowAddTakeaways] = useState(false);
  const [showUpdateTakeaways, setShowUpdateTakeaways] = useState(false);

  useEffect(() => {
    setShowCapAlert(false);
  }, [levelDetails]);
  const handleOpenCapstoneActPop = async () => {
    if (capstoneDetails?.capstonedetails && capstoneDetails?.capstonedetails?.id !== '') {
      dispatch(showProgress(true));
      const data = '';
      await service
        .get(apiEndpoints.JOURNEY_CAPSTONE_ACTIVITY_LEVEL.replace('LEVEL_ID', levelID), data)
        .then((response) => {
          dispatch(showProgress(false));
          dispatch(getCapstoneActivityList('update', response));
          dispatch(getCapstoneActivityID(response[0].id));
        })
        .catch((error) => {
          console.log(error);
          dispatch(showProgress(false));
          dispatch(getCapstoneActivityList('update', []));
          dispatch(getCapstoneActivityID(null));
        });
      setShowCapstoneAct(true);
    } else {
      setShowCapAlert(true);
    }
  };
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClickCap = (event) => {
    setAnchorElc(event.currentTarget);
  };
  const handleDeleteCapstone = async () => {
    setAnchorElc(null);
    const con = window.confirm(`Do you want to delete ${capstoneDetails.capstonedetails.title} ?`);
    if (con) {
      dispatch(showProgress(true));
      await service
        .delete(apiEndpoints.JOURNEY_CAPSTONE_LEVEL.replace('CAP_ID', capstoneID).replace('LEVEL_ID', levelID))
        .then(() => {
          dispatch(getCapstoneID(null));
          dispatch(getCapstoneDetails('delete', []));
          dispatch(getLevelDetails('delCapstoneActCount', []));
          dispatch(showProgress(false));
          notifySuccess('Deleted Successfully');
        })
        .catch((error) => {
          dispatch(showProgress(false));
          console.log(error);
          ErrorToast(error);
        });
    }
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleCloseCapstone = () => {
    setAnchorElc(null);
  };
  const handleClickMenu = async (e) => {
    const selectedMenu = e.target.innerText;
    setAnchorEl(null);
    let levelName;
    if (selectedMenu === 'Edit Level') {
      props.onEditLevelPopup();
    } else if (selectedMenu === 'Delete Level') {
      levelIds.forEach((value) => {
        if (value.id === levelID) {
          levelName = value.title;
        }
      });
      const con = window.confirm(`Do you want to delete  ${levelName}`);
      if (con === true) {
        await service
          .delete(apiEndpoints.JOURNEY_LEVEL_DETAILS.replace('LEVEL_ID', levelID))
          .then(() => {
            dispatch(getJourneyDetails('deleteLevelId', levelID));
            notifySuccess('Deleted Successfully');
          })
          .catch((error) => {
            console.log(error);
          });
      }
    } else if (selectedMenu === 'Change Order') {
      setShowChangeOrder(true);
    }
  };
  const handleOpenChangeOrderGuide = () => {
    setShowChangeOrderGuide(true);
  };
  const handleOpenChangeLevelGuide = (val) => {
    setSelectedGuide(val);
    setShowChangeLevelGuide(true);
  };
  const handleCloseAddNewGuide = () => {
    setShowAddNewGuide(false);
  };
  const handleCloseAddNewAiExercise = () => {
    setShowAddNewAiExercise(false);
  };
  const handleCloseChangeOrder = () => {
    setShowChangeOrder(false);
  };
  const handleCloseChangeOrderGuide = () => {
    setShowChangeOrderGuide(false);
  };
  const handleCloseChangeLevelGuide = () => {
    setShowChangeLevelGuide(false);
  };
  const handleCloseCapstoneAct = () => {
    setShowCapstoneAct(false);
  };
  const handleCloseCapstonePopup = () => {
    setShowAddNewCapstone(false);
  };
  const handleCloseCheckinPopup = () => {
    setShowAddCheckin(false);
  };
  const handleCloseUpdateCheckinPopup = () => {
    setShowUpdateCheckin(false);
  };
  const handleCloseEditCapstonePopup = () => {
    setShowEditNewCapstone(false);
  };
  const handleOpenAddNewGuide = () => {
    setShowAddNewGuide(true);
    setShowViewGuide(false);
  };
  const handleOpenAddAiExercise = () => {
    setShowAddNewAiExercise(true);
  };
  const handleOpenCapstonePopup = () => {
    setShowAddNewCapstone(true);
  };
  const handeleOpenCheckinPopup = () => {
    setShowAddCheckin(true);
  };
  const handleOpenTakeawaysPopup = () => {
    setShowAddTakeaways(true);
  };
  const handeleOpenUpdateCheckinPopup = () => {
    setShowUpdateCheckin(true);
  };

  const handleTakeawayUpdate = () => {
    setShowUpdateTakeaways(true);
  };

  const handleOpenEditCapstonePopup = () => {
    setShowEditNewCapstone(true);
    setAnchorElc(null);
  };
  const handleOpenGuide = (val) => {
    dispatch(getGuideID(val.id));
    setShowAddNewGuide(true);
    setShowViewGuide(true);
  };
  const ordinalSuffixOf = (i) => {
    const j = i % 10;
    const k = i % 100;
    if (j === 1 && k !== 11) {
      return `${i}st`;
    }
    if (j === 2 && k !== 12) {
      return `${i}nd`;
    }
    if (j === 3 && k !== 13) {
      return `${i}rd`;
    }
    return `${i}th`;
  };
  const getLevelTitle = () => {
    if (levelIds !== undefined) {
      if (levelIds.length !== 0) {
        return (
          <Grid item className={classes.journeyLevelTitle}>
            {levelDetails.leveldetails ? levelDetails.leveldetails.title : ''}
          </Grid>
        );
      }
      return (
        <Grid item className={classes.journeyLevelTitle}>
          ...
        </Grid>
      );
    }
    return '';
  };
  const getLevelSubtitle = () => {
    if (levelIds !== undefined) {
      if (levelIds.length !== 0) {
        return (
          <Grid item className={classes.leveldur}>
            {ordinalSuffixOf(levelKey + 1)} Level{' '}
            {levelDetails.leveldetails ? formatDurationSeconds(levelDetails.leveldetails.duration) : null}
          </Grid>
        );
      }
      return (
        <Grid item className={classes.leveldur}>
          ...
        </Grid>
      );
    }
    return '';
  };
  const getLevelMenu = () => {
    if (levelIds !== undefined) {
      if (levelIds.length !== 0) {
        return (
          <Grid item>
            <MoreHorizIcon
              style={{ marginRight: '23px', cursor: 'pointer' }}
              aria-controls="simple-menu"
              aria-haspopup="true"
              onClick={handleClick}
            />
            <Menu
              id="simple-menu"
              anchorEl={anchorEl}
              keepMounted
              open={Boolean(anchorEl)}
              onClose={handleClose}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
            >
              <MenuItem value="Edit Level" className={classes.menuRoot} onClick={handleClickMenu}>
                Edit Level
              </MenuItem>
              <MenuItem value="Change Order" className={classes.menuRoot} onClick={handleClickMenu}>
                Change Order
              </MenuItem>
              <MenuItem value="Delete Level" className={classes.menuRoot} onClick={handleClickMenu}>
                Delete Level
              </MenuItem>
            </Menu>
          </Grid>
        );
      }
      return '';
    }
    return '';
  };
  const getLevelDescription = () => {
    if (levelIds !== undefined) {
      if (levelIds.length !== 0 && levelDetails.leveldetails) {
        return levelDetails.leveldetails.description;
      }
      return '...';
    }
    return '...';
  };
  const getCapstoneDetail = () => {
    const getCapstoneTitle = () => (
      <Grid
        item
        style={{
          fontSize: '14px',
          fontWeight: 600,
          fontStyle: 'normal',
          lineHeight: '17px',
          color: 'rgba(0, 0, 0, 0.4)',
          textAlign: 'left',
          marginTop: '20px',
          paddingLeft: '18px',
        }}
      >
        {capstoneDetails?.capstonedetails?.title}
      </Grid>
    );
    const getCapstoneDescription = () => (
      <Grid
        item
        style={{
          color: 'black',
          fontStyle: 'normal',
          fontWeight: 500,
          fontSize: '14px',
          lineHeight: '21px',
          textAlign: 'left',
          paddingLeft: '18px',
          margin: '20px 0px',
        }}
      >
        {capstoneDetails?.capstonedetails?.description}
      </Grid>
    );
    const getCapstoneMenu = () => {
      if (levelIds !== undefined) {
        if (levelIds.length !== 0) {
          return (
            <Grid item>
              <MoreHorizIcon
                style={{ marginRight: '23px', cursor: 'pointer' }}
                aria-controls="menuCapstone"
                aria-haspopup="true"
                onClick={handleClickCap}
              />
              <Menu
                id="menuCapstone"
                anchorEl={anchorElc}
                keepMounted
                open={Boolean(anchorElc)}
                onClose={handleCloseCapstone}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
              >
                <MenuItem value="Edit Capstone" className={classes.menuRoot} onClick={handleOpenEditCapstonePopup}>
                  Edit Capstone
                </MenuItem>
                <MenuItem value="Delete Capstone" className={classes.menuRoot} onClick={handleDeleteCapstone}>
                  Delete Capstone
                </MenuItem>
              </Menu>
            </Grid>
          );
        }
        return '';
      }
      return '';
    };
    if (capstoneDetails) {
      if (capstoneDetails.capstonedetails) {
        if (capstoneDetails.capstonedetails.id !== '') {
          return (
            <>
              <Grid container direction="row" justifyContent="space-between" alignItems="center">
                <Grid item>
                  <Grid container direction="column" justifyContent="flex-start" alignItems="flex-start">
                    {getCapstoneTitle()}
                    {getCapstoneDescription()}
                  </Grid>
                </Grid>
                {capstoneDetails.capstonedetails.title !== '' ? getCapstoneMenu() : null}
              </Grid>
              <AddNewCapstoneLayout
                showAddCapstone
                clickFn={handleOpenCapstonePopup}
                clickCheckinFn={handeleOpenCheckinPopup}
                clickTakeawayFn={handleOpenTakeawaysPopup}
              />
            </>
          );
        }
      }
      return (
        <AddNewCapstoneLayout
          showAddCapstone={journeyDetails?.levels?.length > 0}
          clickFn={handleOpenCapstonePopup}
          clickCheckinFn={handeleOpenCheckinPopup}
          clickTakeawayFn={handleOpenTakeawaysPopup}
        />
      );
    }
    return '';
  };
  const getCapstoneActivities = () => {
    if (!levelIds || levelIds.length === 0) return;

    return (
      <Grid container spacing={2} style={{ padding: '12px' }}>
        <Grid item>
          <CustomButton
            variant="contained"
            type="primary"
            label={`${
              levelDetails.leveldetails ? levelDetails.leveldetails.capstoneActivitiesCount : 0
            } Capstone Activities`}
            onClick={handleOpenCapstoneActPop}
            size="large"
          />
        </Grid>

        {journeyDetails.checkinId && (
          <Grid item>
            <CustomButton
              onClick={handeleOpenUpdateCheckinPopup}
              variant="contained"
              type="primary"
              label="Journey check-in"
              size="large"
              style={{
                paddingLeft: '45px',
                paddingRight: '45px',
                width: '40%',
              }}
            />
          </Grid>
        )}

        {journeyDetails?.journeyTakeaways > 0 && (
          <Grid item>
            <CustomButton
              onClick={handleTakeawayUpdate}
              variant="contained"
              type="primary"
              label={`${journeyDetails?.journeyTakeaways} Takeaways added`}
              size="large"
              style={{
                paddingLeft: '45px',
                paddingRight: '45px',
                width: '40%',
              }}
            />
          </Grid>
        )}

        {showCapAlert && (
          <Grid item>
            <Alert severity="error" onClose={() => setShowCapAlert(false)}>
              Please add Capstone first !!!
            </Alert>
          </Grid>
        )}
      </Grid>
    );
  };
  const notifyError = (msg) => {
    toast.error(
      <>
        {msg.map((x) => (
          <div> {x.param === undefined ? `${x.msg}` : `${x.param} is ${x.msg}`}</div>
        ))}
      </>,
      {
        position: toast.POSITION.TOP_CENTER,
        hideProgressBar: true,
      },
    );
  };
  const getCapstoneActvityDetails = () => {
    if (levelIds !== undefined) {
      if (levelIds.length !== 0) {
        return (
          <Grid container justifyContent="space-between" alignItems="center" style={{ marginTop: '20px' }}>
            <Grid item>
              <div
                style={{
                  fontSize: '18px',
                  fontWeight: 600,
                  fontStyle: 'normal',
                  lineHeight: '22px',
                  color: 'rgba(0, 0, 0, 0.4)',
                  textAlign: 'left',
                  marginLeft: '20px',
                }}
              >
                {`${levelDetails.leveldetails ? levelDetails.leveldetails.guides.length : 0} Learning Units`}
              </div>
            </Grid>
            <Grid item>
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginRight: '20px' }}>
                <Typography
                  className={classes.addAiExerciseText}
                  onClick={handleOpenAddNewGuide}
                  style={{ cursor: 'pointer' }}
                >
                  + Add Guide
                </Typography>
                <Typography
                  className={classes.addAiExerciseText}
                  onClick={handleOpenAddAiExercise}
                  style={{ cursor: 'pointer' }}
                >
                  + Add Ai Exercise
                </Typography>
              </div>
            </Grid>
          </Grid>
        );
      }
      return (
        <Grid container justifyContent="space-between" alignItems="center" style={{ marginTop: '20px' }}>
          <Grid item>
            <div
              style={{
                fontSize: '18px',
                fontWeight: 600,
                fontStyle: 'normal',
                lineHeight: '22px',
                color: 'rgba(0, 0, 0, 0.4)',
                textAlign: 'left',
                marginLeft: '20px',
              }}
            >
              0 Learning Units
            </div>
          </Grid>
          <Grid item>
            <button
              type="submit"
              variant="contained"
              onClick={() => {
                notifyError([{ msg: 'Please Add Level first' }]);
              }}
              style={{
                width: '51px',
                height: '40px',
                background: '#FEFEFE',
                cursor: 'pointer',
                border: 'none',
                marginRight: '1vw',
              }}
            >
              <FeatherPlus />
            </button>
          </Grid>
        </Grid>
      );
    }
    return '';
  };
  const showJourneyCard = () => {
    if (levelIds) {
      if (levelIds.length !== 0) {
        if (levelDetails.leveldetails !== undefined) {
          return levelDetails.leveldetails.guides.map((val) => (
            <JourneyCard
              change={handleOpenChangeOrderGuide}
              level={() => {
                handleOpenChangeLevelGuide(val);
              }}
              handleOpenGuide={() => {
                if (val?.type === 'guide') handleOpenGuide(val);
              }}
              values={val}
            />
          ));
        }
        return <div></div>;
      }
      return <div style={{ height: '12.5vh' }}></div>;
    }
    return <div style={{ height: '12.5vh' }}></div>;
  };
  return (
    <Paper elevation={0} className={classes.root}>
      <Paper elevation={0} style={{ width: '41vw', backgroundColor: Theme.palette.ternary.main }}>
        <Grid container direction="row" justifyContent="space-between" alignItems="center">
          <Grid item>
            <Grid container direction="column" justifyContent="flex-start" alignItems="flex-start">
              {getLevelTitle()}
              {getLevelSubtitle()}
            </Grid>
          </Grid>
          {getLevelMenu()}
        </Grid>
        <Divider variant="middle" />

        <div
          style={{
            fontSize: '14px',
            fontWeight: 600,
            fontStyle: 'normal',
            lineHeight: '17px',
            color: 'rgba(0, 0, 0, 0.4)',
            textAlign: 'left',
            marginTop: '20px',
            paddingLeft: '18px',
          }}
        >
          GOAL OF THIS LEVEL
        </div>
        <div
          style={{
            fontStyle: 'normal',
            fontWeight: 500,
            fontSize: '12px',
            lineHeight: '21px',
            textAlign: 'left',
            paddingLeft: '18px',
            margin: '20px 0px',
          }}
        >
          {getLevelDescription()}
        </div>

        <Divider variant="middle" />
        {getCapstoneDetail()}
        <Divider variant="middle" />
        {getCapstoneActivities()}
      </Paper>
      {getCapstoneActvityDetails()}
      {showAddNewGuide && (
        <JourneyAddnewGuide open close={handleCloseAddNewGuide} add edit={false} view={showViewGuide} />
      )}
      {showAddNewAiExercise && (
        <AddAiExercise
          isOpen
          handleClose={handleCloseAddNewAiExercise}
          journeyId={journeyDetails?.id}
          levelId={levelID}
        />
      )}
      {showJourneyCard()}
      {showAddNewCapstone && <AddNewCapstone open close={handleCloseCapstonePopup} add selected="" edit={false} />}
      {showEditNewCapstone && <AddNewCapstone open close={handleCloseEditCapstonePopup} add selected="" edit />}
      {showCapstoneAct && <CapstoneActivityPopup open close={handleCloseCapstoneAct} add selected="" edit={false} />}
      {showChangeOrder && <ChangeOrderLevel open close={handleCloseChangeOrder} />}
      {showChangeOrderGuide && <ChangeOrderGuide open close={handleCloseChangeOrderGuide} />}
      {showChangeLevelGuide && <ChangeLevelGuide open close={handleCloseChangeLevelGuide} values={selectedGuide} />}
      {showAddCheckin && (
        <HandleCheckin open close={handleCloseCheckinPopup} journeyId={journeyDetails.id} mode="add" />
      )}
      {showUpdateCheckin && (
        <HandleCheckin
          open
          close={handleCloseUpdateCheckinPopup}
          checkinId={journeyDetails.checkinId}
          journeyId={journeyDetails.id}
          mode="edit"
        />
      )}
      {showAddTakeaways && <Takeaway showAddTakeaways={showAddTakeaways} setShowAddTakeaways={setShowAddTakeaways} />}
      {showUpdateTakeaways && (
        <Takeaway isEdit showAddTakeaways={showUpdateTakeaways} setShowAddTakeaways={setShowUpdateTakeaways} />
      )}
    </Paper>
  );
}
